import React, { useEffect, useRef } from "react";
import logo from "./images/logo.png";
import abm from "./images/abm.png";
import orcon from "./images/orcon.png";
import nigrir from "./images/nigrir.png";
import neoVinci from "./images/logo_neo.svg";
import headerImg from "./images/header.jpg";
import {
  Box,
  Button,
  Container,
  Grid,
} from "@mui/material";
import { Link } from "react-router-dom";
import { ROUTES_CORE } from "commons/constants/paths";
import {
  StyledNavbarList,
  StyledNavbarListItem,
  StyledLoginButton,
  StyledLogo,
  StyledFooter,
  StyledFooterSection,
  StyledFooterImg,
  StyledFooterImgSpan,
  StyledHeaderHolder,
  StyledHeaderImg,
  StyledHeaderSection,
  StyledHeaderSubtitle,
  StyledHeaderTitle,
  StyledAnchor,
  StyledContactWayTitle,
  StyledFooterAnchor,
  StyledFooterMenu,
  StyledFooterMenuLink,
  StyledFooterTitle,
  StyledInfoSectionDescription,
  StyledSectionTitle
} from "./Home.styled";
import { useAppDispatch } from "commons/store/hooks";
import MedicalCenter from "../components/MedicalCenter";
import {
  PROJECT_NAME,
  PROJECT_TECHNICAL_EMAIL,
  PROJECT_TECHNICAL_PHONE
} from "commons/constants/env";
import {StyledButton, StyledHeaderButtons} from "../Improve/Home.styled";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import SubjectOutlinedIcon from "@mui/icons-material/SubjectOutlined";

function Home() {
  const dispatch = useAppDispatch();
  let info: any = useRef();

  /** Tab title controller */
  useEffect(() => {
    document.title = `${PROJECT_NAME} - Strona Główna`;
    return () => {
      document.title = PROJECT_NAME;
    };
  }, [dispatch]);

  return (
    <div>
      <header>
        <Container maxWidth="lg">
          <Grid container spacing={0} direction="row" justifyContent="space-between" alignItems="center">
            <Grid container item lg={3} xs={12} spacing={0}>
               <StyledLogo src={logo} alt="Projekt Sapho" />
            </Grid>
            <Grid container item lg={9} xs={12} spacing={0}>
              <StyledNavbarList>
                <StyledNavbarListItem>
                  <Button
                    onClick={() =>
                      window.scrollTo({
                        behavior: 'smooth',
                        top: info.current.offsetTop,
                      })
                    }
                    size="medium"
                  >
                    INFORMACJE O BADANIU
                  </Button>
                </StyledNavbarListItem>
                <StyledNavbarListItem>
                  <StyledLoginButton
                    variant="contained"
                    color="primary"
                    to={ROUTES_CORE.LOGIN}
                    component={Link}
                  >
                    LOGOWANIE
                  </StyledLoginButton>
                </StyledNavbarListItem>
              </StyledNavbarList>
            </Grid>
          </Grid>
        </Container>
      </header>

      <StyledHeaderSection>
        <StyledHeaderImg src={headerImg} alt="Background img"/>
        <StyledHeaderHolder>
          <Container maxWidth="lg">
            <StyledHeaderTitle>
              <b style={{ textTransform: "uppercase" }}>{PROJECT_NAME}</b>
            </StyledHeaderTitle>
            <StyledHeaderSubtitle>
              Wieloośrodkowe, randomizowane, podwójnie zaślepione badanie kliniczne oceniające skuteczność
              i bezpieczeństwo etanerceptu w porównaniu z placebo w leczeniu pacjentów z zespołem SAPHO
            </StyledHeaderSubtitle>
          </Container>
        </StyledHeaderHolder>
        <StyledHeaderButtons>
          <StyledButton
            size="large"
            color="secondary"
            variant="contained"
            onClick={() => window.open(`https://clinicaltrials.gov/study/NCT06011889`, "_blank")}
          >
            <SubjectOutlinedIcon className="button-icon"/>
            Badanie zarejestrowane w bazie ClinicalTrials.gov
          </StyledButton>
          <StyledButton
            size="large"
            color="secondary"
            variant="contained"
            onClick={() => window.open(`https://clinicaltrials.eu/trial/study-on-the-effectiveness-and-safety-of-etanercept-for-patients-with-sapho-syndrome/`, "_blank")}
          >
            <SubjectOutlinedIcon className="button-icon"/>
            Badanie zarejestrowane w bazie ClinicalTrials.eu
          </StyledButton>
        </StyledHeaderButtons>
      </StyledHeaderSection>

      <section ref={info}>
        <Container maxWidth="lg">
          <StyledSectionTitle textAlign="left">
            Co to jest zespół SAPHO?
          </StyledSectionTitle>
          <StyledInfoSectionDescription textAlign="left">
            Zespół SAPHO (ang. Synovitis, Acne, Pustulosis, Hyperostosis, Osteitis) to rzadka zapalna choroba autoimmunologiczna
            (spowodowana niewłaściwym funkcjonowaniem układu odpornościowego który zaczyna atakować swój własny organizm).
            Zespół SAPHO charakteryzująca się współwystępowaniem zapalenia stawów i kości ze zmianami skórnymi takimi jak
            łuszczyca krostkowa i trądzik. Choroba zazwyczaj zaczyna się ok 35-40 roku życia
            (choć może wystąpić między 20 a 60 rokiem życia), i nieco częściej dotyczy kobiet.
          </StyledInfoSectionDescription><br/>
          <StyledInfoSectionDescription textAlign="left">
            Dokładna przyczyna zespołu SAPHO nie jest znana. Przyjmuje się, że za wystąpienie zespołu SAPHO odpowiada
            współudział czynników zakaźnych oraz genetycznych. Z uwagi na brak poznanych czynników wywołujących zespół
            SAPHO nie jest możliwe zapobieganie wystąpienia tej choroby.
          </StyledInfoSectionDescription>
          <StyledInfoSectionDescription textAlign="left"><br/>
            Ze względu na częste w zespole SAPHO zajęcie szkieletu osiowego (kręgosłupa i/lub stawów krzyżowo-biodrowych)
            oraz współwystępowanie łuszczycy (a także rzadziej zapalnych chorób jelit) zespół SAPHO zaliczany
            jest do większej grupy chorób reumatycznych nazywanych spondyloartropatiami (obejmującej takie choroby
            jak zesztywniające zapalenie stawów kręgosłupa, łuszczycowe zapalenie stawów czy reaktywne zapalenie stawów).
          </StyledInfoSectionDescription>

          <StyledSectionTitle textAlign="left">
            Jak często występuje zespół SAPHO?
          </StyledSectionTitle>
          <StyledInfoSectionDescription textAlign="left">
            Zespół SAPHO zaliczany jest do chorób rzadkich. Choć nie znamy dokładnej częstości zachorowania
            na zespół SAPHO w Polsce, wśród osób rasy kaukaskiej (białej) częstość zachorowania
            wynosi 1: 10 000 (jedna osoba na dziesięć tysięcy osób).
          </StyledInfoSectionDescription>

          <StyledSectionTitle textAlign="left">
            Jakie są objawy zespołu SAPHO?
          </StyledSectionTitle>
          <StyledInfoSectionDescription textAlign="left">
            Do najczęstszych objawów zespołu SAPHO zaliczamy:
            <br/><br/>
            <ul style={{ paddingLeft: '20px' }}>
              <li>
                Ból, obrzęk (rzadziej zaczerwienie i wzmożone ucieplenie) okolicy mostka (zapalenie stawów mostkowo-obojczykowych występuje u 63-100% chorych).
                Bóle i obrzęki innych stawów występują rzadziej (u 18-35% chorych) i dotyczą zazwyczaj kolan, stawów skokowych, barków, nadgarstków.
              </li>
              <li>
                Zaczerwienienie, pogrubienie, łuszczenie i obecność krostek (jałowych pęcherzyków ropnych) na skórze rąk i stóp,
                z towarzyszącym uczuciem świądu (łuszczyca krostkowa występuje u 55-92% chorych). U części chorych (8-41%)
                łuszczycy krostkowej może towarzyszyć łuszczyca pospolita, objawiająca się zaczerwienieniem
                i nadmiernym łuszczeniem skóry (początkowo w postaci grudek, a następnie blaszek), z towarzyszącym uczuciem świądu.
              </li>
              <li>
                Przewlekły ból kręgosłupa z towarzyszącym ograniczeniem jego ruchomości (zapalenie kręgosłupa i/lub stawów krzyżowo-biodrowych występuje u 24-66% chorych)
              </li>
              <li>
                Bóle kostne, niekiedy z widocznym poszerzeniem obrysu kości (niebakteryjne zapalenie kości występuje u 11-70% chorych)
              </li>
              <li>
                Na skutek procesu zapalnego u 36% pacjentów w badaniach radiologicznych widoczna jest hiperostoza – nadmierne kostnienie zajętych procesem zapalnym kości.
              </li>
              <li>
                Ciężkie postacie trądziku, najczęściej obejmujące klatkę piersiową i plecy (występują u 6-41% chorych)
              </li>
            </ul>

          </StyledInfoSectionDescription><br/>
          <StyledInfoSectionDescription textAlign="left">
            Zmiany skórne zazwyczaj poprzedzają lub występują równocześnie z zmianami stawowymi, choć zdarza się, że mogą wystąpić również później.
          </StyledInfoSectionDescription>

          <StyledSectionTitle textAlign="left">
            Jak rozpoznaje się zespół SAPHO?
          </StyledSectionTitle>
          <StyledInfoSectionDescription textAlign="left">
            Zespół SAPHO jest rozpoznawany przez lekarza na podstawie charakterystycznych objawów choroby.
          </StyledInfoSectionDescription><br/>
          <StyledInfoSectionDescription textAlign="left">
            Pomocne w rozpoznaniu choroby mogą być również badania radiologiczne. U pacjentów z podejrzeniem zapaleń kości
            stosuje się badania obrazowe takie jak scyntygrafia czy rezonans magnetyczny. W przypadku zapalenia stawów osiowych
            (kręgosłup, stawy krzyżowo-biodrowe) wykonuje się rezonans magnetyczny, zaś w przypadku stawów obwodowych
            (np. mostkowo-obojczykowych) badanie ultrasonograficzne (USG). Niekiedy w przypadkach zapaleń kości może być
            konieczne wykonanie biopsji celem wykluczenia procesu nowotworowego lub infekcyjnego.
          </StyledInfoSectionDescription><br/>
          <StyledInfoSectionDescription textAlign="left">
            Zespołu SAPHO nie da się rozpoznać na podstawie badań laboratoryjnych.
            Choć u większości pacjentów występuje podwyższenie wskaźników stanu zapalnego (CRP, OB.),
            jest to jednak objaw niespecyficzny. Aktualnie nie jest znany żaden specyficzny marker choroby który można by
            oznaczyć z krwi. W zespole SAPHO, w odróżnieniu do innych spondyloartropatii, nieprzydatne jest oznaczanie
            czynnika genetycznego (antygenu HLA-B27, który w tym zespole nie występuje częściej niż w populacji ogólnej).
          </StyledInfoSectionDescription>

          <StyledSectionTitle textAlign="left">
            Jak przebiega zespół SAPHO?
          </StyledSectionTitle>
          <StyledInfoSectionDescription textAlign="left">
            Przebieg zespołu SAPHO jest zróżnicowany. Objawy mogą mieć charakter przewlekły lub nawrotowy (przebiegać
            z okresami nasilenia i samoistnego wyciszenia).
          </StyledInfoSectionDescription><br/>
          <StyledInfoSectionDescription textAlign="left">
            Choć zespół SAPHO nie zagraża życiu, może znacząco obniżać jakości życia pacjentów ze względu na przewlekłe
            występowanie bólu stawów i/lub kości, ograniczając codzienną aktywność pacjentów,
            a także występowanie zmian skórnych.
          </StyledInfoSectionDescription><br/>
          <StyledInfoSectionDescription textAlign="left">
            Zespół SAPHO może także prowadzić do niepełnosprawności - około połowa pacjentów prezentuje objawy ciężkiej
            spondyloartropatii osiowej (przewlekłego bólu kręgosłupa z towarzyszącym ograniczeniem jego ruchomości).
          </StyledInfoSectionDescription><br/>
          <StyledInfoSectionDescription textAlign="left">
            U części pacjentów przewlekłe zapalenie może również prowadzić do lokalnego niszczenia kości (najczęściej
            w obrębie stawów mostkowo-obojczykowych).
          </StyledInfoSectionDescription>

          <StyledSectionTitle textAlign="left">
            Jakie są metody leczenia zespołu SAPHO?
          </StyledSectionTitle>
          <StyledInfoSectionDescription textAlign="left">
            Z uwagi na rzadki charakter choroby obecnie nie istnieje żaden lek zarejestrowany w leczeniu zespołu SAPHO,
            brakuje również standardów opieki nad pacjentami. Rzadkie występowanie choroby sprawia, że wszystkie dane
            dotyczące leczenia zespołu SAPHO opierają się na opisach przypadków lub doświadczeniach pojedynczych ośrodków leczniczych.
            Z uwagi na brak rzetelnych danych naukowych nie istnieją wytyczne ani rekomendacje dotyczące leczenia choroby.
          </StyledInfoSectionDescription><br/>
          <StyledInfoSectionDescription textAlign="left">
            Najczęściej w leczeniu objawów kostno-stawowych pacjentów z zespołem SAPHO próbuje się stosować preparaty
            przeciwbólowo-przeciwzapalne - niesteroidowe leki przeciwzapalne (NLPZ).
          </StyledInfoSectionDescription><br/>
          <StyledInfoSectionDescription textAlign="left">
            Podejmowane są również próby użycia leków stosowanych u pacjentów z innymi chorobami zapalnymi stawów
            - klasycznymi lekami modyfikującymi przebieg choroby (kLMPCH/leki immunomodulujące)
            - takimi jak sulfasalazyna czy metotreksat.
          </StyledInfoSectionDescription><br/>
          <StyledInfoSectionDescription textAlign="left">
            Do innych stosowanych terapii należą sterydoterapia (glikokortykosteroidy podawane miejscowo w formie iniekcji
            lub ogólnoustrojowo doustnie lub dożylnie) czy leczenie bisfosfonianami (lekami hamującymi obrót kostny,
            próby podejmowano zwłaszcza w przypadkach występowania zapalenia kości).
          </StyledInfoSectionDescription><br/>
          <StyledInfoSectionDescription textAlign="left">
            W zmniejszaniu dokuczliwych objawów choroby pomocna bywa również rehabilitacja czy fizykoterapia.
          </StyledInfoSectionDescription>
          <StyledInfoSectionDescription textAlign="left">
            Na dzień dzisiejszy nie są znane leki które umożliwiłyby całkowite wyleczenie choroby. Celem obecnego leczenia
            jest uzyskanie remisji – stanu wyciszenia choroby, w którym nie daje ona żadnych objawów. Niestety,
            podczas stosowania wyżej wymienionych leków (NLPZ, kLMPCH, sterydów) całkowitą remisję osiąga jedynie ok 1/3 pacjentów.
          </StyledInfoSectionDescription><br/>
          <StyledInfoSectionDescription textAlign="left">
            W leczeniu zespołu SAPHO podejmowane są również próby stosowania nowszych leków które zrewolucjonizowały
            leczenie innych chorób reumatycznych, tzw. leków biologicznych i syntetycznych leków celowanych
            (grupa leków bezpośrednio wpływająca na cząsteczki biologiczne biorące udział w powstawaniu choroby).
            Najwięcej dowodów na skuteczność w leczeniu zespołu SAPHO posiadają leki biologiczne z grupy inhibitorów TNF.
            Na podstawie opisu łącznie 63 przypadków wykazano, że inhibitory TNF mogą wywołać całkowitą remisję
            (całkowite ustąpienie objawów choroby) u aż 79,4% leczonych pacjentów. Leki te niestety do niedawna były niedostępne
            dla polskich pacjentów z zespołem SAPHO z uwagi na ich wysoki koszt i brak refundacji.
          </StyledInfoSectionDescription>

          <StyledSectionTitle textAlign="left">
            Projekt badawczy SAPHO
          </StyledSectionTitle>
          <StyledInfoSectionDescription textAlign="left">
            W Narodowym Instytucie Geriatrii, Reumatologii i Rehabilitacji w Warszawie, dzięki środkom uzyskanym
            z Agencji Badań Medycznych, wystartowało pierwsze na świecie badanie kliniczne oceniające skuteczność
            i bezpieczeństwo leku biologicznego z grupy inhibitorów TNF – etanerceptu - u pacjentów z zespołem SAPHO.
          </StyledInfoSectionDescription><br/>
          <StyledInfoSectionDescription textAlign="left">
            Badanie SAPHO jest badaniem klinicznym II/III fazy. Etanercept jest lekiem biologicznym zarejestrowanym
            i stosowanym w leczeniu innych chorób reumatycznych (m.in. innych spondyloartropatii do których zaliczany
            jest zespół SAPHO). Badanie SAPHO ma na celu ocenę skuteczność i bezpieczeństwo leku w nowym wskazaniu.
          </StyledInfoSectionDescription><br/>
          <StyledInfoSectionDescription textAlign="left">
            Badanie jest skierowane do osób pełnoletnich, z rozpoznanym zespołem SAPHO oraz nieskutecznością dotychczasowego leczenia.
          </StyledInfoSectionDescription><br/>
          <StyledInfoSectionDescription textAlign="left">
            W ramach badania wszyscy uczestniczy otrzymają bezpłatną opiekę medyczną obejmującą badania diagnostyczne,
            leczenie etanerceptem, opiekę lekarską i pielęgniarską.
          </StyledInfoSectionDescription><br/>
          <StyledInfoSectionDescription textAlign="left">
            Udział w badaniu trwa do 78 tygodni i obejmie do 6 tygodni badań przesiewowych, 48 tygodni leczenia
            oraz 24 tygodnie obserwacji po zakończeniu leczenia.
          </StyledInfoSectionDescription><br/>
          <StyledInfoSectionDescription textAlign="left" style={{ marginLeft: "16px" }}>
            Zapraszamy do kontaktu - zarówno pacjentów z zespołem SAPHO jak i lekarzy opiekujących się pacjentami.
          </StyledInfoSectionDescription><br/>
          <StyledInfoSectionDescription textAlign="left">
            W badaniu leczenie etanerceptem jest stosowane jako dodatek do dotychczas stosowanego leczenia.
            Wszyscy pacjenci biorący udział w badaniu klinicznym otrzymają etanercept, jednak część z nich (1/3 pacjentów)
            przez pierwsze 12 tygodni leczenia zamiast etanerceptu będzie otrzymywała placebo (imitację leku).
          </StyledInfoSectionDescription><br/>
          <StyledInfoSectionDescription textAlign="left">
            Skontaktuj się z nami telefonicznie lub mailowo: jakub.wronski@spartanska.pl.
            <br/><br/>
            Telefon:
            22 688 06 31
            22 688 06 32
            <br/><br/>
            Opracował dr hab. n. med. Jakub Wroński
          </StyledInfoSectionDescription>
        </Container>
      </section>

      <section>
        <Container maxWidth="lg">
          <MedicalCenter />
        </Container>
      </section>

      <StyledFooter>
        <Container maxWidth="lg">
          <StyledFooterSection>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <StyledFooterTitle>Menu:</StyledFooterTitle>
                <StyledFooterMenu>
                  <StyledFooterMenuLink onClick={() =>
                    window.scrollTo({
                      behavior: 'smooth',
                      top: info.current.offsetTop,
                    })
                  }>
                    INFORMACJE O BADANIU
                  </StyledFooterMenuLink><br/>
                  <StyledFooterMenuLink
                    href={'https://clinicaltrials.gov/study/NCT06011889'}
                    target={'_blank'}
                  >
                    ClinicalTrials.gov
                  </StyledFooterMenuLink><br/>
                  <StyledFooterMenuLink
                    href={'https://clinicaltrials.eu/trial/study-on-the-effectiveness-and-safety-of-etanercept-for-patients-with-sapho-syndrome/'}
                    target={'_blank'}
                  >
                    ClinicalTrials.eu
                  </StyledFooterMenuLink>
                </StyledFooterMenu>
              </Grid>
              <Grid item xs={12} md={4}>
                <StyledFooterTitle>Kontakt w sprawach technicznych:</StyledFooterTitle>
                <StyledContactWayTitle>e-mail: </StyledContactWayTitle>
                <StyledAnchor href={`mailto:${PROJECT_TECHNICAL_EMAIL}`}>
                  {PROJECT_TECHNICAL_EMAIL}
                </StyledAnchor>
                <br/>
                <StyledContactWayTitle>telefon: </StyledContactWayTitle>
                <StyledFooterAnchor href={`tel:${PROJECT_TECHNICAL_PHONE}`}>
                  {PROJECT_TECHNICAL_PHONE}
                </StyledFooterAnchor>
              </Grid>
              <Grid item xs={12} md={4}>
                <StyledFooterTitle>Logowanie do eCRF:</StyledFooterTitle>
                <Box>
                  <StyledLoginButton
                    color="primary"
                    variant="contained"
                    to={ROUTES_CORE.LOGIN}
                    component={Link}
                  >
                    LOGOWANIE
                  </StyledLoginButton>
                </Box>
              </Grid>
            </Grid>
          </StyledFooterSection>
          <StyledFooterSection>
            {/*<StyledFooterDescription>*/}
            {/*  Lorem ipsum*/}
            {/*</StyledFooterDescription>*/}
            {/*<StyledFooterDescriptionContact>*/}
            {/*  e-mail: ${PROJECT_EMAIL} | phone: ${PROJECT_PHONE} <br/>*/}
            {/*  <br/>*/}
            {/*  Working days: Monday-Friday, hours: 9:00-17:00*/}
            {/*</StyledFooterDescriptionContact>*/}
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <StyledFooterImg src={logo} alt="Projekt Sapho"/>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <StyledFooterImgSpan>Kontraktowa organizacja badawcza (CRO):</StyledFooterImgSpan>
                <StyledFooterImg src={orcon} alt="Orcon Pharma logo"/>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <StyledFooterImg src={nigrir} alt="NIGRIR logo"/>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <StyledFooterImg src={abm} alt="ABM logo"/>
              </Grid>
              {/*<Grid item xs={12} sm={6} md={4} lg={2} style={{marginRight: "40px"}}>*/}
              {/*  <StyledFooterImg src={pharmindex} alt="Pharmindex logo"/>*/}
              {/*</Grid>*/}
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <StyledFooterImgSpan>Technical organizator:</StyledFooterImgSpan>
                <StyledFooterImg src={neoVinci} alt="Neo-Vinci logo"/>
              </Grid>
            </Grid>
          </StyledFooterSection>
        </Container>
      </StyledFooter>
    </div>
  );
}

export default Home;
